import React from 'react';
import {
  DialogContent,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import AppDialog, { AppDialogHeader } from '../common/AppDialog';
import {
  Business as BusinessIcon,
} from '@mui/icons-material';
import { Company, CreateCompanyRequest, UpdateCompanyRequest } from '../../types';
import { useLanguage } from '../../contexts/LanguageContext';
import CompanyForm from './CompanyForm';

interface CompanyDialogProps {
  open: boolean;
  company?: Company | null;
  onClose: () => void;
  onSubmit: (data: CreateCompanyRequest | UpdateCompanyRequest) => Promise<void>;
  isLoading?: boolean;
}

const CompanyDialog: React.FC<CompanyDialogProps> = ({
  open,
  company,
  onClose,
  onSubmit,
  isLoading = false,
}) => {
  const { t } = useLanguage();
  const theme = useTheme();
  const mobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const handleSubmit = async (data: CreateCompanyRequest | UpdateCompanyRequest) => {
    await onSubmit(data);
    onClose();
  };

  return (
    <AppDialog presentation="form" footerInside closeDisabled={isLoading}
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={mobile}
      PaperProps={{
        sx: { minHeight: '400px', borderRadius: mobile ? 0 : 2, overflow: 'hidden' }
      }}
    >
      <AppDialogHeader icon={<BusinessIcon />} subtitle={company?.name}>
        {company ? t('companies.editCompany') : t('companies.createCompany')}
      </AppDialogHeader>

      <DialogContent dividers>
        <CompanyForm
          company={company}
          onSubmit={handleSubmit}
          onCancel={onClose}
          isLoading={isLoading}
        />
      </DialogContent>
    </AppDialog>
  );
};

export default CompanyDialog;
